import { Routes } from '@angular/router';

import { advaniaServicesSegments } from '@advania-cosoftware/wolf-router';

export const serverManagementRoutes: Routes = [
    {
        path: advaniaServicesSegments.windowsServerManagement,
        loadComponent: () =>
            import('./pages/windows-server-management-page/windows-server-management.page').then(
                (m) => m.WindowsServerManagementPage,
            ),
    },
    {
        path: advaniaServicesSegments.windowsServerManagementInAzure,
        loadComponent: () =>
            import('./pages/windows-server-management-in-azure-page/windows-server-management-in-azure.page').then(
                (m) => m.WindowsServerManagementInAzurePage,
            ),
    },
    {
        path: advaniaServicesSegments.linuxServerManagement,
        loadComponent: () =>
            import('./pages/linux-server-management-page/linux-server-management.page').then(
                (m) => m.LinuxServerManagementPage,
            ),
    },
    {
        path: advaniaServicesSegments.linuxServerManagementInAzure,
        loadComponent: () =>
            import('./pages/linux-server-management-in-azure-page/linux-server-management-in-azure.page').then(
                (m) => m.LinuxServerManagementInAzurePage,
            ),
    },
    {
        path: advaniaServicesSegments.virtualServer,
        loadComponent: () => import('./pages/virtual-server-page/virtual-server.page').then((m) => m.VirtualServerPage),
    },
];
